import { DiscountMeasureUnits } from '@invivodf/module-discount-sdk'

export const MEASURE_UNITS = {
  DEFAULT: { text: 'ctx.discount.form.select-measure-unit', value: '' },
  ANY: { text: 'ctx.discount.form.any', value: DiscountMeasureUnits.Any },
  TON: { text: 'ctx.discount.form.ton', value: DiscountMeasureUnits.Ton },
  UNIT: { text: 'ctx.discount.form.unit', value: DiscountMeasureUnits.Unit },
  QUINTAL: { text: 'ctx.discount.form.quintal', value: DiscountMeasureUnits.Quintal },
  KILO: { text: 'ctx.discount.form.kg', value: DiscountMeasureUnits.Kilo },
  LITER: { text: 'ctx.discount.form.liter', value: DiscountMeasureUnits.Liter },
  MILLILITER: { text: 'ctx.discount.form.milliliter', value: DiscountMeasureUnits.Milliliter },
  LINEAR_METER: { text: 'ctx.discount.form.linear-meter', value: DiscountMeasureUnits.LinearMeter },
  HECTARE: { text: 'ctx.discount.form.hectare', value: DiscountMeasureUnits.Hectare },
  POUND: { text: 'ctx.discount.form.pound', value: DiscountMeasureUnits.Pound },
  OUNCE: { text: 'ctx.discount.form.ounce', value: DiscountMeasureUnits.Ounce },
  GALLON: { text: 'ctx.discount.form.gallon', value: DiscountMeasureUnits.Gallon },
} as const
